import {graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';
import * as tracking from '../tracking';
import {trackAndCommitMutation} from '../tracking/amplitude/TrackMutation';

const mutation = graphql`
	mutation updateCustomFieldValueMutation($input: UpdateCustomFieldValueInput!) {
		updateCustomFieldValue(input: $input) {
			customFieldValue {
				node {
					id
					key
					displayName
					value
				}
			}
		}
	}
`;

function getConfigs(input) {
	return [
		{
			type: 'RANGE_ADD',
			parentID: input.entityId,
			edgeName: 'customFieldValue',
			connectionInfo: [
				{
					key: 'TimeRegistrations_customFieldValues',
					rangeBehavior: 'append',
				},
			],
		},
	];
}

function getOptimisticResponse(input) {
	return {
		updateCustomFieldValue: {
			customFieldValue: {
				node: {
					id: input.id,
					key: input.key,
					value: input.value,
					displayName: undefined,
				},
			},
		},
	};
}

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('CustomFieldValue - Updated');

	return trackAndCommitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: getConfigs(input),
		optimisticResponse: getOptimisticResponse(input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
